// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Uuid from "../../externals/Uuid.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let EmptyProductName = /* @__PURE__ */Primitive_exceptions.create("CatalogProductEditFormMutations.EmptyProductName");

let ShopIdNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogProductEditFormMutations.ShopIdNotFound");

let TaxIdNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogProductEditFormMutations.TaxIdNotFound");

let FormIdNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogProductEditFormMutations.FormIdNotFound");

let Raw = {};

let query = Client.gql(["mutation createProduct($input: InputCreateProduct!)  {\ncreateProduct(input: $input)  {\n__typename  \nid  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.createProduct;
  return {
    createProduct: {
      __typename: value$1.__typename,
      id: value$1.id
    }
  };
}

function serialize(value) {
  let value$1 = value.createProduct;
  let value$2 = value$1.id;
  let value$3 = value$1.__typename;
  let createProduct = {
    __typename: value$3,
    id: value$2
  };
  return {
    createProduct: createProduct
  };
}

function serializeInputObjectInputCreateProduct(inp) {
  let a = inp.designation;
  let a$1 = inp.color;
  let a$2 = inp.kind;
  let a$3 = inp.family;
  let a$4 = inp.producer;
  let a$5 = inp.region;
  let a$6 = inp.beerType;
  let a$7 = inp.wineType;
  let a$8 = inp.whiteWineType;
  let a$9 = inp.internalNote;
  let a$10 = inp.categoryId;
  return {
    name: inp.name,
    designation: a !== undefined ? a : undefined,
    color: a$1 !== undefined ? (
        a$1 === "ORANGE" ? "ORANGE" : (
            a$1 === "RED" ? "RED" : (
                a$1 === "AMBER" ? "AMBER" : (
                    a$1 === "DARK" ? "DARK" : (
                        a$1 === "BLACK" ? "BLACK" : (
                            a$1 === "BLOND" ? "BLOND" : (
                                a$1 === "ROSE" ? "ROSE" : "WHITE"
                              )
                          )
                      )
                  )
              )
          )
      ) : undefined,
    kind: a$2 === "SPIRITUOUS" ? "SPIRITUOUS" : (
        a$2 === "BEER" ? "BEER" : (
            a$2 === "WINE" ? "WINE" : "SIMPLE"
          )
      ),
    family: a$3 !== undefined ? a$3 : undefined,
    producer: a$4 !== undefined ? a$4 : undefined,
    country: inp.country,
    region: a$5 !== undefined ? a$5 : undefined,
    beerType: a$6 !== undefined ? a$6 : undefined,
    wineType: a$7 !== undefined ? (
        a$7 === "EFFERVESCENT" ? "EFFERVESCENT" : "STILL"
      ) : undefined,
    whiteWineType: a$8 !== undefined ? (
        a$8 === "SWEET" ? "SWEET" : (
            a$8 === "SEMIDRY" ? "SEMIDRY" : (
                a$8 === "SOFT" ? "SOFT" : "DRY"
              )
          )
      ) : undefined,
    internalNote: a$9 !== undefined ? a$9 : undefined,
    taxId: inp.taxId,
    categoryId: a$10 !== undefined ? a$10 : undefined,
    shopId: inp.shopId
  };
}

function serializeVariables(inp) {
  return {
    input: serializeInputObjectInputCreateProduct(inp.input)
  };
}

function makeVariables(input, param) {
  return {
    input: input
  };
}

function makeInputObjectInputCreateProduct(name, designation, color, kind, family, producer, country, region, beerType, wineType, whiteWineType, internalNote, taxId, categoryId, shopId, param) {
  return {
    name: name,
    designation: designation,
    color: color,
    kind: kind,
    family: family,
    producer: producer,
    country: country,
    region: region,
    beerType: beerType,
    wineType: wineType,
    whiteWineType: whiteWineType,
    internalNote: internalNote,
    taxId: taxId,
    categoryId: categoryId,
    shopId: shopId
  };
}

let CreateProductMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateProduct: serializeInputObjectInputCreateProduct,
  makeVariables: makeVariables,
  makeInputObjectInputCreateProduct: makeInputObjectInputCreateProduct
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let CreateProductMutation_useWithVariables = include.useWithVariables;

let CreateProductMutation = {
  CreateProductMutation_inner: CreateProductMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateProduct: serializeInputObjectInputCreateProduct,
  makeVariables: makeVariables,
  makeInputObjectInputCreateProduct: makeInputObjectInputCreateProduct,
  use: use,
  useWithVariables: CreateProductMutation_useWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["mutation updateProduct($id: ID!, $input: InputUpdateProduct!)  {\nupdateProduct(id: $id, input: $input)  {\n__typename  \nid  \nupdatedAt  \nname  \nformattedDescription  \nformattedOrigin  \ncategory  {\n__typename  \nid  \nformattedName  \n}\n\ntax  {\n__typename  \nvalue  \n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.updateProduct;
  let value$2 = value$1.formattedDescription;
  let value$3 = value$1.category;
  let value$4 = value$1.tax;
  return {
    updateProduct: {
      __typename: value$1.__typename,
      id: value$1.id,
      updatedAt: Scalar.Datetime.parse(value$1.updatedAt),
      name: value$1.name,
      formattedDescription: !(value$2 == null) ? value$2 : undefined,
      formattedOrigin: value$1.formattedOrigin,
      category: !(value$3 == null) ? ({
          __typename: value$3.__typename,
          id: value$3.id,
          formattedName: value$3.formattedName
        }) : undefined,
      tax: {
        __typename: value$4.__typename,
        value: value$4.value
      }
    }
  };
}

function serialize$1(value) {
  let value$1 = value.updateProduct;
  let value$2 = value$1.tax;
  let value$3 = value$2.value;
  let value$4 = value$2.__typename;
  let tax = {
    __typename: value$4,
    value: value$3
  };
  let value$5 = value$1.category;
  let category;
  if (value$5 !== undefined) {
    let value$6 = value$5.formattedName;
    let value$7 = value$5.id;
    let value$8 = value$5.__typename;
    category = {
      __typename: value$8,
      id: value$7,
      formattedName: value$6
    };
  } else {
    category = null;
  }
  let value$9 = value$1.formattedOrigin;
  let value$10 = value$1.formattedDescription;
  let formattedDescription = value$10 !== undefined ? value$10 : null;
  let value$11 = value$1.name;
  let value$12 = value$1.updatedAt;
  let value$13 = Scalar.Datetime.serialize(value$12);
  let value$14 = value$1.id;
  let value$15 = value$1.__typename;
  let updateProduct = {
    __typename: value$15,
    id: value$14,
    updatedAt: value$13,
    name: value$11,
    formattedDescription: formattedDescription,
    formattedOrigin: value$9,
    category: category,
    tax: tax
  };
  return {
    updateProduct: updateProduct
  };
}

function serializeInputObjectInputUpdateProductMetaData(inp) {
  let a = inp.shopifyProductId;
  return {
    shopifyProductId: a !== undefined ? a : undefined
  };
}

function serializeInputObjectInputUpdateProduct(inp) {
  let a = inp.name;
  let a$1 = inp.designation;
  let a$2 = inp.color;
  let a$3 = inp.kind;
  let a$4 = inp.family;
  let a$5 = inp.producer;
  let a$6 = inp.country;
  let a$7 = inp.region;
  let a$8 = inp.beerType;
  let a$9 = inp.wineType;
  let a$10 = inp.whiteWineType;
  let a$11 = inp.internalNote;
  let a$12 = inp.taxId;
  let a$13 = inp.categoryId;
  let a$14 = inp.metadata;
  return {
    name: a !== undefined ? a : undefined,
    designation: a$1 !== undefined ? a$1 : undefined,
    color: a$2 !== undefined ? (
        a$2 === "ORANGE" ? "ORANGE" : (
            a$2 === "RED" ? "RED" : (
                a$2 === "AMBER" ? "AMBER" : (
                    a$2 === "DARK" ? "DARK" : (
                        a$2 === "BLACK" ? "BLACK" : (
                            a$2 === "BLOND" ? "BLOND" : (
                                a$2 === "ROSE" ? "ROSE" : "WHITE"
                              )
                          )
                      )
                  )
              )
          )
      ) : undefined,
    kind: a$3 !== undefined ? (
        a$3 === "SPIRITUOUS" ? "SPIRITUOUS" : (
            a$3 === "BEER" ? "BEER" : (
                a$3 === "WINE" ? "WINE" : "SIMPLE"
              )
          )
      ) : undefined,
    family: a$4 !== undefined ? a$4 : undefined,
    producer: a$5 !== undefined ? a$5 : undefined,
    country: a$6 !== undefined ? a$6 : undefined,
    region: a$7 !== undefined ? a$7 : undefined,
    beerType: a$8 !== undefined ? a$8 : undefined,
    wineType: a$9 !== undefined ? (
        a$9 === "EFFERVESCENT" ? "EFFERVESCENT" : "STILL"
      ) : undefined,
    whiteWineType: a$10 !== undefined ? (
        a$10 === "SWEET" ? "SWEET" : (
            a$10 === "SEMIDRY" ? "SEMIDRY" : (
                a$10 === "SOFT" ? "SOFT" : "DRY"
              )
          )
      ) : undefined,
    internalNote: a$11 !== undefined ? a$11 : undefined,
    taxId: a$12 !== undefined ? a$12 : undefined,
    categoryId: a$13 !== undefined ? a$13 : undefined,
    metadata: a$14 !== undefined ? serializeInputObjectInputUpdateProductMetaData(a$14) : undefined
  };
}

function serializeVariables$1(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateProduct(inp.input)
  };
}

function makeVariables$1(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputUpdateProduct(name, designation, color, kind, family, producer, country, region, beerType, wineType, whiteWineType, internalNote, taxId, categoryId, metadata, param) {
  return {
    name: name,
    designation: designation,
    color: color,
    kind: kind,
    family: family,
    producer: producer,
    country: country,
    region: region,
    beerType: beerType,
    wineType: wineType,
    whiteWineType: whiteWineType,
    internalNote: internalNote,
    taxId: taxId,
    categoryId: categoryId,
    metadata: metadata
  };
}

function makeInputObjectInputUpdateProductMetaData(shopifyProductId, param) {
  return {
    shopifyProductId: shopifyProductId
  };
}

let UpdateProductMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateProduct: serializeInputObjectInputUpdateProduct,
  serializeInputObjectInputUpdateProductMetaData: serializeInputObjectInputUpdateProductMetaData,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateProduct: makeInputObjectInputUpdateProduct,
  makeInputObjectInputUpdateProductMetaData: makeInputObjectInputUpdateProductMetaData
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let UpdateProductMutation_useWithVariables = include$1.useWithVariables;

let UpdateProductMutation = {
  UpdateProductMutation_inner: UpdateProductMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateProduct: serializeInputObjectInputUpdateProduct,
  serializeInputObjectInputUpdateProductMetaData: serializeInputObjectInputUpdateProductMetaData,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateProduct: makeInputObjectInputUpdateProduct,
  makeInputObjectInputUpdateProductMetaData: makeInputObjectInputUpdateProductMetaData,
  use: use$1,
  useWithVariables: UpdateProductMutation_useWithVariables
};

function optionFromString(str) {
  if (str === "") {
    return;
  } else {
    return str;
  }
}

function makeCreateProductInput(state, shop) {
  let name = state.name;
  let tmp;
  if (name === "") {
    throw {
      RE_EXN_ID: EmptyProductName,
      Error: new Error()
    };
  }
  tmp = name;
  let id = Stdlib_Option.map(state.tax, tax => tax.id);
  let tmp$1;
  if (id !== undefined) {
    tmp$1 = id;
  } else {
    throw {
      RE_EXN_ID: TaxIdNotFound,
      Error: new Error()
    };
  }
  let tmp$2;
  if (shop !== undefined) {
    tmp$2 = shop.id;
  } else {
    throw {
      RE_EXN_ID: ShopIdNotFound,
      Error: new Error()
    };
  }
  return makeInputObjectInputCreateProduct(tmp, optionFromString(state.designation), state.color, state.kind, optionFromString(state.family), Stdlib_Option.getOr(optionFromString(state.producer), null), state.country, optionFromString(state.region), optionFromString(state.beerType), state.wineType, state.whiteWineType, undefined, tmp$1, Stdlib_Option.map(state.categoryId, prim => prim), tmp$2, undefined);
}

function useCreateProduct() {
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  let activeShop = Auth.useActiveShop();
  return React.useCallback((param, state) => {
    let input = makeCreateProductInput(state, activeShop);
    return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      input: input
    })), undefined, param => param.createProduct.id);
  }, [activeShop]);
}

function makeUpdateProductInput(state) {
  let name = state.name;
  let tmp;
  if (name === "") {
    throw {
      RE_EXN_ID: EmptyProductName,
      Error: new Error()
    };
  }
  tmp = name;
  let id = Stdlib_Option.map(state.tax, tax => tax.id);
  let tmp$1;
  if (id !== undefined) {
    tmp$1 = id;
  } else {
    throw {
      RE_EXN_ID: TaxIdNotFound,
      Error: new Error()
    };
  }
  return makeInputObjectInputUpdateProduct(tmp, optionFromString(state.designation), state.color, state.kind, optionFromString(state.family), Stdlib_Option.getOr(optionFromString(state.producer), null), state.country, optionFromString(state.region), optionFromString(state.beerType), state.wineType, state.whiteWineType, undefined, tmp$1, undefined, undefined, undefined);
}

function useUpdateProduct() {
  let match = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback((productId, state) => {
    let id;
    if (productId !== undefined) {
      if (Uuid.fromString(productId) !== undefined) {
        id = productId;
      } else {
        throw {
          RE_EXN_ID: FormIdNotFound,
          Error: new Error()
        };
      }
    } else {
      throw {
        RE_EXN_ID: FormIdNotFound,
        Error: new Error()
      };
    }
    let input = makeUpdateProductInput(state);
    return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: id,
      input: input
    })), undefined, param => I18n.t("The product information have been correctly updated."));
  }, []);
}

export {
  EmptyProductName,
  ShopIdNotFound,
  TaxIdNotFound,
  FormIdNotFound,
  CreateProductMutation,
  UpdateProductMutation,
  optionFromString,
  makeCreateProductInput,
  useCreateProduct,
  makeUpdateProductInput,
  useUpdateProduct,
}
/* query Not a pure module */
